module.exports = __webpack_public_path__ + "static/media/duoprint-main.f2defa63.jpg";